module.exports = __webpack_public_path__ + "img/Grid view Icon - white.635a041f.svg";